type SeatUsage = {
  /** Seats still available. `Infinity` when the org has no seat limit. */
  remaining: number;
  hasReachedLimit: boolean;
  isUnlimited: boolean;
};

/**
 * Derive seat availability for an organization from its optional `seatLimit`
 * and the number of members currently occupying seats. A null/undefined limit
 * means unlimited seats.
 */
export const getSeatUsage = (
  seatLimit: number | null | undefined,
  usedCount: number
): SeatUsage => {
  if (seatLimit == null) {
    return {
      remaining: Number.POSITIVE_INFINITY,
      hasReachedLimit: false,
      isUnlimited: true,
    };
  }

  const remaining = Math.max(0, seatLimit - usedCount);
  return {
    remaining,
    hasReachedLimit: remaining <= 0,
    isUnlimited: false,
  };
};
